<div class="page-content page-fill">
    <div class="row flex-fill">
        <div class="col-5 flex-fill border-end">
            <div class="grid-fill">
                <dx-data-grid
                    #categoryGrid
                    [dataSource]="categories"
                    keyExpr="id"
                    [showBorders]="true"
                    [rowAlternationEnabled]="false"
                    [focusedRowEnabled]="true"
                    (onFocusedRowChanged)="categoryRowChanged($event)"
                    (onToolbarPreparing)="onToolbarPreparing($event)"
                >
                    <dxi-column dataField="name"></dxi-column>
                    <dxi-column dataField="displayOrder" caption="Order" [sortIndex]="1" [sortOrder]="'asc'"></dxi-column>

                    <div *dxTemplate="let data of 'toolbarButtons'">
                        <dx-button text="Add" type="default" (onClick)="editCategory(categoryModal)"></dx-button>
                        <dx-button
                            text="Edit"
                            type="default"
                            (onClick)="editCategory(categoryModal, categoryGrid)"
                            [disabled]="!selectedCategory"
                        ></dx-button>
                        <dx-button
                            text="Delete"
                            type="danger"
                            (onClick)="deleteCategory(categoryGrid)"
                            [disabled]="!selectedCategory"
                        ></dx-button>
                    </div>

                    <dxo-selection mode="single"></dxo-selection>
                    <dxo-search-panel [visible]="true"></dxo-search-panel>
                </dx-data-grid>
            </div>
        </div>
        <div class="col-7 flex-fill border-end">
            <div class="grid-fill">
                <dx-data-grid
                    #interestGrid
                    [dataSource]="selectedCategory && selectedCategory.interests"
                    keyExpr="id"
                    [showBorders]="true"
                    [focusedRowEnabled]="true"
                    (onFocusedRowChanged)="interestRowChanged($event)"
                    (onToolbarPreparing)="onToolbarPreparing($event)"
                >
                    <dxi-column dataField="name"></dxi-column>
                    <dxi-column dataField="displayOrder" caption="Order" [sortIndex]="1" [sortOrder]="'asc'"></dxi-column>

                    <div *dxTemplate="let data of 'toolbarButtons'">
                        <dx-button
                            text="Add"
                            type="default"
                            (onClick)="editInterest(interestModal)"
                            [disabled]="!selectedCategory"
                        ></dx-button>
                        <dx-button
                            text="Edit"
                            type="default"
                            (onClick)="editInterest(interestModal, interestGrid)"
                            [disabled]="!selectedInterest"
                        ></dx-button>
                        <dx-button
                            text="Delete"
                            type="danger"
                            (onClick)="deleteInterest(categoryGrid)"
                            [disabled]="!selectedInterest"
                        ></dx-button>
                    </div>

                    <dxo-selection mode="single"></dxo-selection>
                    <dxo-search-panel [visible]="true"></dxo-search-panel>
                </dx-data-grid>
            </div>
        </div>
    </div>
</div>

<ng-template #categoryModal>
    <div class="modal-content">
        <div class="modal-header">
            <h4 class="modal-title pull-left">Interest Category</h4>
        </div>
        <div class="modal-body">
            <dx-form [formData]="selectedCategory">
                <dxi-item dataField="name"></dxi-item>
                <dxi-item dataField="displayOrder" [label]="{ text: 'Order' }"></dxi-item>
            </dx-form>
        </div>
        <div class="modal-footer">
            <button type="button" class="btn btn-success" (click)="saveDialog(categoryGrid)">Save</button>
            <button type="button" class="btn btn-default" (click)="closeDialog()">Cancel</button>
        </div>
    </div>
</ng-template>

<ng-template #interestModal>
    <div class="modal-content">
        <div class="modal-header">
            <h4 class="modal-title pull-left">Interest</h4>
        </div>
        <div class="modal-body">
            <dx-form [formData]="dialogInterest">
                <dxi-item dataField="name"></dxi-item>
                <dxi-item
                    dataField="interestCategoryId"
                    [editorType]="'dxSelectBox'"
                    [editorOptions]="{ items: categories, displayExpr: 'name', valueExpr: 'id' }"
                ></dxi-item>
                <dxi-item dataField="displayOrder" [label]="{ text: 'Order' }"></dxi-item>
            </dx-form>
        </div>
        <div class="modal-footer">
            <button type="button" class="btn btn-success" (click)="saveDialog(interestGrid)">Save</button>
            <button type="button" class="btn btn-default" (click)="closeDialog()">Cancel</button>
        </div>
    </div>
</ng-template>
